import React from "react";
import { LoaderBox, StyledLoader } from "./Loader.styles";

export const Loader = () => (
    <LoaderBox>
        <StyledLoader />
    </LoaderBox>
);